import type { FaireProductEntity } from "../../entity_types/product";

export const p_fnuyfkcfr3: FaireProductEntity = {
  token: "p_fnuyfkcfr3",
  type: "product",
  name: "Start and Sun Statement Earrings",
  brandToken: "b_cn7om55jvr",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/abd4820d429f1a243b16eff61791d5b91ca28d79d4f9117057ca0cb218f47652.jpeg",
  galleryImageUrls: [],
  priceDollars: 27.02,
  description:
    "\nGarner a celestial new appearance with our Star & Moon Statement Earrings! These statement earrings boast glistening gold alloy star and moon pendants that are further complimented by prominent blue glass crystals. Pair these gold earrings with your favorite gold bracelet to complete the jewelry set!\n",
  tags: [],
  msrpDollars: 54.04,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:37.899Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
